import { merge } from "lodash";
import Alert from "./Alert";
import AlertTitle from "./AlertTitle";
import AppBar from "./AppBar";
import Chip from "./Chip";
import InputLabel from "./InputLabel";
import OutlinedInput from "./OutlinedInput";
import Button from "./Button";
import TextField from "./TextField";

/**
 *
 * @param theme
 */
/**
 * Component overrides for theme
 * @param theme - Material-UI theme object
 * @returns Theme component overrides configuration
 */
export const ComponentsOverrides = (theme: any): any => {
  return merge(
    Alert(theme),
    AlertTitle(),
    AppBar(),
    Button(theme),
    Chip(theme),
    InputLabel(theme),
    OutlinedInput(theme),
    TextField(),
  );
};
